export const adminRecoveryAgentConstants = {
    ADMIN_GET_ALL_RECOVERY_AGENTS_REQUEST:"ADMIN_GET_ALL_RECOVERY_AGENTS_REQUEST",
    ADMIN_GET_ALL_RECOVERY_AGENTS_SUCCESS:"ADMIN_GET_ALL_RECOVERY_AGENTS_SUCCESS",
    ADMIN_GET_ONE_RECOVERY_AGENT_REQUEST:"ADMIN_GET_ONE_RECOVERY_AGENT_REQUEST",
    ADMIN_GET_ONE_RECOVERY_AGENT_SUCCESS:"ADMIN_GET_ONE_RECOVERY_AGENT_SUCCESS",
    ADMIN_GET_TEAM_LIST_REQUEST:"ADMIN_GET_TEAM_LIST_REQUEST",
    ADMIN_GET_TEAM_LIST_SUCCESS:"ADMIN_GET_TEAM_LIST_SUCCESS",
    ADMIN_RECOVERYAGENT_CLEAR: "ADMIN_RECOVERYAGENT_CLEAR",

};